/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/no-danger */
/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import { useAlert, useMe, useResponseUser, useTest } from '@orientaction/hooks';
import { userService } from '@orientaction/services';
import { getFromLS } from '@orientaction/utils';
import classNames from 'classnames';
import HtmlReactParser from 'html-react-parser';
import { find, groupBy, map, sumBy } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import ResumeTestModal from '../../ResumeTestModal';
import DialogNotConnected from './Dialog';
import style from './style';

const qs = require('qs');

const MinorTestTaking = () => {
  const [questionNumber, setQuestionNumber] = useState<number>(1);
  const [swiper1, setSwiper] = useState<any>();
  const [textNext, setTextNext] = useState('Question suivante');
  const [valueArray, setValueArray] = useState<any>([]);
  const [indexArray, setIndexArray] = useState(0);
  const [dataToPost, setDataToPost] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [protectedTag, setProtectedTag] = useState<any>();
  const [openBlock, setOpenBlock] = useState(false);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [savedProgress, setSavedProgress] = useState<any>(null);
  const progressReady = useRef(false);
  const draftSaveTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const startRef = useRef<number>(Date.now());
  const { me } = useMe();

  const { id: testId }: any = useParams();
  const history = useHistory();
  const progressKey = `test_progress_${testId}`;

  const { getTest, test, setProgress, getResponsesPopulate, loadPage } = useTest();
  const { postResponseUsers, getMyResponseUserForTest, saveResponseUserProgress } =
    useResponseUser();
  const alert = useAlert();

  const classes = style();

  const user = JSON.parse(getFromLS('userInfos') || '{}');
  const token = localStorage.getItem('userToken') ? getFromLS('userToken') : '';
  const isConnected = Boolean(user?.id);

  useEffect(() => {
    startRef.current = Date.now();
  }, []);

  const getTestQuestions = async () => {
    const filter = qs.stringify(
      {
        populate: {
          questions: {
            populate: {
              responses: {
                populate: ['variable'],
                sort: ['order:asc'],
              },
            },
            sort: ['order:asc'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    const testData = await getTest(testId, filter);
    setOpenBlock(testData?.attributes?.isDesabled || testData?.attributes?.isArchived);
    removeAttr(testData);
  };

  useEffect(() => {
    getTestQuestions();
  }, []);

  const mapDataCalcul = async (array: any) => {
    const searchParams = qs.stringify(
      {
        filters: {
          id: {
            $in: array,
          },
        },
      },
      {
        encodeValuesOnly: true,
      }
    );

    const data: any = await getResponsesPopulate(searchParams);

    const flattenedData = data.data.data.flatMap((item: any) =>
      item.attributes.variable.data.map((variable: any) => ({
        variableKey: variable.attributes.variableKey,
        variableValue: item.attributes.variableValue,
      }))
    );

    const dataGroupByVariableKey = groupBy(flattenedData, 'variableKey');

    const dataMapValue = map(dataGroupByVariableKey, (responsesx: any, key: string) => ({
      somme: sumBy(responsesx, 'variableValue'),
      key,
    }));

    return {
      ...dataToPost,
      variableA: find(dataMapValue, ['key', 'A'])?.somme || 0,
      variableB: find(dataMapValue, ['key', 'B'])?.somme || 0,
      timePassed: Math.round((Date.now() - startRef.current) / 1000),
    };
  };

  const postDataAfterCalculSum = async () => {
    const newDataToPost = await mapDataCalcul(dataToPost.responses);

    if (isConnected) {
      const saved = await saveResponseUserProgress({
        testId: test.id,
        responses: newDataToPost.responses,
        timePassed: newDataToPost.timePassed,
        state: 'over',
      });
      return saved;
    }

    const postedResponse = await postResponseUsers(newDataToPost);
    return postedResponse;
  };

  // init swiper for getting swiper data with initial value
  const initSwiper = async (swiper: any) => {
    setSwiper(swiper);
    const totalQuestions = test.attributes ? test.attributes.questions.data.length : 0;

    if (isConnected) {
      try {
        const record = await getMyResponseUserForTest(testId);
        if (record?.state === 'over') {
          handleRestartTest();
          return;
        }
        if (record?.state === 'started') {
          const draftResponses: any[] = (record.responses || []).map((r: any) => `${r.id}`);
          const currentIndex = Math.min(draftResponses.length, Math.max(totalQuestions - 1, 0));
          if (draftResponses.length > 0) {
            setSavedProgress({
              valueArray: draftResponses,
              indexArray: currentIndex,
              questionNumber: currentIndex + 1,
              totalQuestions,
              testTitle: test.attributes?.title || '',
              fromBackend: true,
            });
            setShowResumeModal(true);
            setProgress(0, totalQuestions);
            return;
          }
        }
      } catch {
        alert.openSimpleAlert('Impossible de récupérer le test en cours');
      }

      progressReady.current = true;
      setProgress(parseInt(swiper.activeIndex, 10), parseInt(totalQuestions as any, 10));
      return;
    }

    try {
      const saved = localStorage.getItem(progressKey);
      if (saved) {
        const persist = JSON.parse(saved);
        if (persist.indexArray > 0 || persist.valueArray?.length > 0) {
          setSavedProgress(persist);
          setShowResumeModal(true);
          setProgress(0, totalQuestions);
          return;
        }
      }
    } catch {
      alert.openSimpleAlert('Impossible de récupérer le test en cours');
    }

    progressReady.current = true;
    setProgress(parseInt(swiper.activeIndex, 10), parseInt(totalQuestions as any, 10));
  };

  const handleResumeTest = () => {
    if (!savedProgress || !swiper1) return;
    const progress = savedProgress;
    if (progress.valueArray?.length) setValueArray(progress.valueArray);
    if (typeof progress.indexArray === 'number' && progress.indexArray > 0) {
      swiper1.slideTo(progress.indexArray, 0);
      setIndexArray(progress.indexArray);
    }
    if (typeof progress.questionNumber === 'number' && progress.questionNumber > 1) {
      setQuestionNumber(progress.questionNumber);
    }

    const totalQuestions = test.attributes ? test.attributes.questions.data.length : 0;
    const idx = progress.indexArray || 0;
    setProgress(idx, totalQuestions);
    if (idx + 1 === totalQuestions) {
      setTextNext('Voir mes résultats');
    }
    progressReady.current = true;
    setShowResumeModal(false);
    setSavedProgress(null);
  };

  const handleRestartTest = async () => {
    localStorage.removeItem(progressKey);

    if (isConnected) {
      try {
        await saveResponseUserProgress({
          testId,
          responses: [],
          timePassed: 0,
          state: 'started',
        });
      } catch {
        alert.openSimpleAlert('Erreur lors de la sauvegarde du test en cours');
      }
    }

    setValueArray([]);
    setIndexArray(0);
    setQuestionNumber(1);
    setTextNext('Question suivante');
    if (swiper1) swiper1.slideTo(0, 0);
    setProgress(0, test.attributes ? test.attributes.questions.data.length : 0);
    progressReady.current = true;
    setShowResumeModal(false);
    setSavedProgress(null);
    startRef.current = Date.now();
  };

  const slideChange = (slide: any) => {
    setProgress(
      parseInt(slide.activeIndex, 10),
      parseInt(test.attributes.questions.data.length, 10)
    );
    setIndexArray(parseInt(slide.activeIndex, 10));
    if (
      parseInt(slide.activeIndex, 10) + 1 ===
      parseInt(test.attributes.questions.data.length, 10)
    ) {
      setTextNext('Voir mes résultats');
    } else {
      setTextNext('Question suivante');
    }
  };

  const changeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newArray: any = [...valueArray];
    const val = (event.target as HTMLInputElement).value;
    newArray[indexArray] = val;
    setValueArray(newArray);
  };

  const removeAttr = (testData: any) => {
    const tags: any = document.getElementsByTagName('meta');
    setProtectedTag({
      attributes: {
        title: document.title,
        image: tags[5].content,
        description: tags.description.content,
      },
    });
    document.title = testData.attributes.title;
    tags.description.content = testData.attributes?.description;
    tags[5].content = testData.attributes?.image;
    tags[4].content = testData.attributes?.image;
  };

  // function to go to the next swiper if it's not the end one
  const checkNextSwipe = async () => {
    if (
      valueArray[parseInt(swiper1.activeIndex, 10)] !== '' &&
      valueArray[parseInt(swiper1.activeIndex, 10)]
    ) {
      if (
        parseInt(swiper1.activeIndex, 10) + 1 ===
        parseInt(test.attributes.questions.data.length, 10)
      ) {
        // put here the function to post or store user's response
        setLoading(true);
        const postedResponse = await postDataAfterCalculSum();
        localStorage.removeItem(progressKey);
        if (me) {
          await userService.modifyUser({
            token,
            counterTest: me.counterTest ? parseInt(me?.counterTest, 10) + 1 : 1,
            id: user?.id,
          });
        }
        if (!user.id) {
          setOpen(true);
        } else {
          // removeAttr(protectedTag);
          history.push(`/congrats/${postedResponse.id}`);
        }
        setLoading(false);
      } else {
        setQuestionNumber(questionNumber + 1);
        swiper1.slideNext();
      }
    }
  };

  const handlePrevious = () => {
    setQuestionNumber(questionNumber - 1);
    swiper1.slidePrev();
  };

  const redirectLogic = () => {
    removeAttr(protectedTag);
    if (user.id) {
      history.push('/main');
    } else {
      history.push('/');
    }
  };

  useEffect(() => {
    const dataMapedToPost = {
      users_permissions_users: [`${user.id}`],
      responses: valueArray,
      test: test.id,
    };
    setDataToPost(dataMapedToPost);
  }, [valueArray, indexArray]);

  useEffect(() => {
    if (!testId || !test?.attributes || !progressReady.current) return;
    const totalQuestions = test.attributes.questions.data.length;

    if (!isConnected) {
      try {
        const progress = {
          valueArray,
          indexArray,
          questionNumber,
          totalQuestions,
          testTitle: test.attributes.title || '',
        };
        localStorage.setItem(progressKey, JSON.stringify(progress));
      } catch {
        alert.openSimpleAlert('Impossible de récupérer le test en cours');
      }
      return;
    }

    const filledResponses = valueArray.filter(
      (v: any) => v !== undefined && v !== null && v !== ''
    );
    if (filledResponses.length === 0) return;

    if (draftSaveTimer.current) clearTimeout(draftSaveTimer.current);
    draftSaveTimer.current = setTimeout(() => {
      const elapsed = Math.round((Date.now() - startRef.current) / 1000);
      saveResponseUserProgress({
        testId,
        responses: filledResponses,
        timePassed: elapsed,
        state: 'started',
      }).catch(() => undefined);
    }, 500);

    return () => {
      if (draftSaveTimer.current) clearTimeout(draftSaveTimer.current);
    };
  }, [valueArray, indexArray, questionNumber]);

  const goToSignupPage = () => {
    removeAttr(protectedTag);
    history.push('/signup?from=test');
  };

  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <>
      {loadPage || loading || !test?.attributes ? (
        <div className={classes.bodycenter}>
          <CircularProgress style={{ color: 'white' }} />
        </div>
      ) : !openBlock ? (
        <>
          <Grid container={true} style={{ paddingTop: 'env(safe-area-inset-top)' }}>
            <Grid item={true} md={2} sm={12}>
              {!test?.attributes?.useGlobalTimer && questionNumber !== 1 && (
                <Button
                  startIcon={<ArrowBack />}
                  variant="outlined"
                  className={classes.previousButton}
                  onClick={handlePrevious}>
                  Question précédente
                </Button>
              )}
            </Grid>
            <Grid item={true} xs={12} md={8} sm={12}>
              <Grid className={classes.takingTestContainer} container={true}>
                <Grid className={classes.questionTitle} item={true} sm={12} md={12}>
                  <h1 className={classes.testTitle}>Question {questionNumber}</h1>
                </Grid>

                <Grid className={classes.questionSliderContainer} container={true}>
                  <Grid item={true} xs={12} sm={12} md={12}>
                    <Swiper
                      onSlideChange={slideChange}
                      spaceBetween={50}
                      slidesPerView={1}
                      onSwiper={initSwiper}
                      allowTouchMove={false}>
                      {(test.attributes ? test.attributes.questions.data : []).map(
                        (question: any, index: number) => {
                          return (
                            <SwiperSlide key={question.id}>
                              {/* {test?.attributes?.useGlobalTimer && indexArray === index && (
                                <TimerTest
                                  timer={
                                    question?.timer
                                      ? question?.timer
                                      : test?.attributes?.globalTimer
                                  }
                                  onEnd={() => handleNext()}
                                />
                              )} */}
                              <div
                                className={classes.questionText}
                                dangerouslySetInnerHTML={{
                                  __html: question?.attributes?.title,
                                }}
                              />
                              {question?.attributes?.mediaUrl && (
                                <div
                                  style={{
                                    marginTop: 16,
                                    marginBottom: 16,
                                    display: 'flex',
                                    justifyContent: 'center',
                                  }}>
                                  {question.attributes.mediaType === 'image' ? (
                                    <img
                                      src={question.attributes.mediaUrl}
                                      alt="Question"
                                      style={{
                                        width: 350,
                                        height: 250,
                                        objectFit: 'cover',
                                        borderRadius: 9,
                                      }}
                                    />
                                  ) : (
                                    question.attributes.mediaType === 'video' && (
                                      <iframe
                                        width="350"
                                        height="250"
                                        src={question.attributes.mediaUrl}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                      />
                                    )
                                  )}
                                </div>
                              )}
                              <FormControl style={{ width: '100%' }} component="fieldset">
                                <RadioGroup
                                  className={classes.responseItemsContainer}
                                  aria-label="question"
                                  value={valueArray[indexArray] ?? ''}
                                  onChange={changeValue}>
                                  {(question ? question?.attributes?.responses?.data : []).map(
                                    (response: any) => {
                                      return (
                                        <FormControlLabel
                                          key={response.id}
                                          value={response.id}
                                          className={classes.formControlLabel}
                                          classes={{ label: classes.label }}
                                          checked={
                                            parseInt(valueArray[indexArray], 10) ===
                                            parseInt(response.id, 10)
                                          }
                                          control={
                                            <Radio
                                              color="default"
                                              checkedIcon={
                                                <span
                                                  className={classNames(
                                                    classes.icon,
                                                    classes.checkedIcon
                                                  )}
                                                />
                                              }
                                              icon={<span className={classes.icon} />}
                                            />
                                          }
                                          label={HtmlReactParser(response.attributes.title)}
                                        />
                                      );
                                    }
                                  )}
                                </RadioGroup>
                              </FormControl>
                              <div className={classes.buttonContainer}>
                                <Button
                                  endIcon={<ArrowForward />}
                                  variant="outlined"
                                  className={classes.button}
                                  onClick={checkNextSwipe}>
                                  {textNext}
                                </Button>
                              </div>
                            </SwiperSlide>
                          );
                        }
                      )}
                    </Swiper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item={true} md={2} sm={12} />
          </Grid>
          <DialogNotConnected
            open={open}
            handleClose={handleClose}
            goToSignupPage={goToSignupPage}
          />

          <ResumeTestModal
            open={showResumeModal && Boolean(savedProgress)}
            testTitle={savedProgress?.testTitle || test?.attributes?.title || 'Test'}
            questionNumber={savedProgress?.questionNumber || 1}
            totalQuestions={savedProgress?.totalQuestions}
            onClose={handleRestartTest}
            onResume={handleResumeTest}
            onRestart={handleRestartTest}
          />
        </>
      ) : (
        <div className={classes.flexCenterMessage}>
          <Grid container={true} direction="column" justifyContent="center" alignItems="center">
            <Grid item={true} xs={12}>
              <h3 className={classes.title} style={{ color: 'white' }}>
                Nous sommes désolés mais ce test n’est plus disponible
              </h3>
            </Grid>
            <Grid item={true} xs={12}>
              <Button className={classes.btnPrimary} onClick={redirectLogic}>
                <span className={classes.textHeader}>Aller vers E-ORIENTACTION</span>
              </Button>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

export default MinorTestTaking;
